import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  isLoading: boolean;
  isBannerVisible: boolean;
  showFloater: boolean;
  currentTab: 'active' | 'completed';
  toast: {
    message: string;
    type: 'success' | 'error' | 'info' | 'warning';
    isVisible: boolean;
  };
}

const initialState: UIState = {
  isLoading: false,
  isBannerVisible: false,
  showFloater: false,
  currentTab: 'active',
  toast: {
    message: '',
    type: 'info',
    isVisible: false,
  },
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setBannerVisible: (state, action: PayloadAction<boolean>) => {
      state.isBannerVisible = action.payload;
    },
    setShowFloater: (state, action: PayloadAction<boolean>) => {
      state.showFloater = action.payload;
    },
    setCurrentTab: (state, action: PayloadAction<'active' | 'completed'>) => {
      state.currentTab = action.payload;
    },
    showToast: (
      state,
      action: PayloadAction<{
        message: string;
        type: 'success' | 'error' | 'info' | 'warning';
      }>
    ) => {
      state.toast = {
        ...action.payload,
        isVisible: true,
      };
    },
    hideToast: (state) => {
      state.toast.isVisible = false;
    },
  },
});

export const {
  setLoading,
  setBannerVisible,
  setShowFloater,
  setCurrentTab,
  showToast,
  hideToast,
} = uiSlice.actions;

export default uiSlice.reducer;
